import {autoserialize} from 'cerialize';
import User from "@/ts/interfaces/User";

export default class Client {
    @autoserialize public team_id: number;
    @autoserialize public name: string;
    @autoserialize public short_description: string;
    @autoserialize public department: string;
    @autoserialize public contact_person: string;
    @autoserialize public function_contact_person: string;
    @autoserialize public phone: string;
    @autoserialize public mobile_phone: string;
    @autoserialize public email: string;
    @autoserialize public street: string;
    @autoserialize public zip: string;
    @autoserialize public city: string;
    @autoserialize public state: string;
    @autoserialize public order_number: string;
    @autoserialize public ust_id: string;
    @autoserialize public space_size: number;
    @autoserialize public space_size_updated: string;
    @autoserialize public space_limit: number;
    @autoserialize public space_limit_exceeded: boolean;
    @autoserialize public created_at: string;
    @autoserialize public user_accounts: number;
    @autoserialize public users: User[];
    @autoserialize public office_enabled: boolean;
    @autoserialize public offers_disabled: boolean;
    @autoserialize public packet_id: number;

    constructor(team_id: number,
                name: string,
                short_description: string,
                department: string,
                contact_person: string,
                function_contact_person: string,
                phone: string,
                mobile_phone: string,
                email: string,
                street: string,
                zip: string,
                city: string,
                state: string,
                order_number: string,
                ust_id: string,
                space_size: number,
                space_size_updated: string,
                space_limit: number,
                space_limit_exceeded: boolean,
                created_at: string,
                user_accounts: number,
                users: User[],
                office_enabled: boolean,
                offers_enabled: boolean,
                packet_id: number
    ) {

        this.team_id = team_id;
        this.name = name;
        this.short_description = short_description;
        this.department = department;
        this.contact_person = contact_person;
        this.function_contact_person = function_contact_person;
        this.phone = phone;
        this.mobile_phone = mobile_phone;
        this.email = email;
        this.street = street;
        this.zip = zip;
        this.city = city;
        this.state = state;
        this.order_number = order_number;
        this.ust_id = ust_id;
        this.space_size = space_size;
        this.space_size_updated = space_size_updated;
        this.space_limit = space_limit;
        this.space_limit_exceeded = space_limit_exceeded;
        this.created_at = created_at;
        this.user_accounts = user_accounts;
        this.users = users;
        this.office_enabled = office_enabled;
        this.offers_disabled = !offers_enabled;
        this.packet_id = packet_id
    }
}
